import { render, staticRenderFns } from "./OrdersContent.vue?vue&type=template&id=c6fa112e&scoped=true&"
import script from "./OrdersContent.vue?vue&type=script&lang=js&"
export * from "./OrdersContent.vue?vue&type=script&lang=js&"
import style0 from "./OrdersContent.vue?vue&type=style&index=0&id=c6fa112e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6fa112e",
  null
  
)

export default component.exports